// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import implementationTrainingSessionEntity from './entities/implementation-training-session.json';
import implementationTrainingSessionMenu from '../pages/implementation-training-session/menu.json';
import implementationTrainingSessionFullForm from '../pages/implementation-training-session/forms/full.json';
import implementationTrainingSessionContextForm from '../pages/implementation-training-session/forms/context.json';
import implementationTrainingSessionMiniForm from '../pages/implementation-training-session/forms/mini.json';
import implementationTrainingSessionLookupForm from '../pages/implementation-training-session/forms/lookup.json';
import implementationTrainingSessionTableView from '../pages/implementation-training-session/views/table.json';
import implementationTrainingSessionCardsView from '../pages/implementation-training-session/views/cards.json';
import implementationTrainingSessionDashboardView from '../pages/implementation-training-session/views/dashboard.json';

/** Тип запису «Навчальне заняття» зі сторінками пакета: меню, форми та подання з pages/implementation-training-session/. */
export const implementationTrainingSessionDefinition: IRecordTypeDefinition = {
  ...implementationTrainingSessionEntity,
  views: assembleViewSet({
      table: implementationTrainingSessionTableView,
      cards: implementationTrainingSessionCardsView,
      dashboard: implementationTrainingSessionDashboardView,
  }),
  form: implementationTrainingSessionFullForm,
  forms: { full: implementationTrainingSessionFullForm, context: implementationTrainingSessionContextForm, mini: implementationTrainingSessionMiniForm, lookup: implementationTrainingSessionLookupForm },
  menu: implementationTrainingSessionMenu,
} as IRecordTypeDefinition;
